import { NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { AgeClass } from '@tanzspass/shared';
import { School } from '@tanzspass/shared';
import { SafeHtmlPipe } from '../../safe-html.pipe';
import { AgeClassService } from '../../services/age-class.service';
import { SchoolService } from '../../services/school.service';
import { TsHttpService } from '../../services/ts-http.service';

@Component({
  selector: 'ts-course-toolbar-menu',
  templateUrl: './course-toolbar-menu.component.html',
  styleUrls: ['./course-toolbar-menu.component.css'],
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    NgFor,
    MatMenuItem,
    RouterLink,
    MatDivider,
    SafeHtmlPipe,
  ],
  host: { ngSkipHydration: 'true' },
})
export class CourseToolbarMenuComponent implements OnInit {
  public ageClasses: AgeClass[];
  public school: School = new School();
  assetsRoot = TsHttpService.assetsRoot;

  constructor(
    private ageClassSrv: AgeClassService,
    private schoolSrv: SchoolService,
  ) {}

  ngOnInit() {
    this.schoolSrv.current().subscribe((school) => {
      this.school = school;
      this.ageClassSrv.findAll().subscribe((ageClasses) => {
        this.ageClasses = ageClasses.filter((ageClass) => {
          return this.school.show_holiday_courses || ageClass.nameUrl !== 'ferienprogramm';
        });
      });
    });
  }
}
